<template>
  <div id="app">
<nav class="bg-primary-900">
      <div class="flex justify-between ml-4 lg:m-auto bg-white nav-cut-left max-w-7xl">
        <div class="py-3 bg-primary-900 lg:pl-20 lg:pt-6"><img src="@/assets/img/logon.webp" style="max-height:45px;" alt="Logotipo de HBIM, una novedosa herramienta de integración online y visual de un bien cultural."></div>
        <div class="">
          <ul class="h-nav justify-end items-center mr-0 list-none px-5 font-sans font-semibold tracking-wide text-primary-400 nav-cut-right text-lg hidden lg:flex">
            <li class="hover-nav"><router-link :to="{ name: 'home' }">Inicio</router-link></li>
            <li class="hover-nav"><router-link :to="{ name: 'advantages'}">Ventajas</router-link></li>
            <li class="hover-nav mr-32"><router-link :to="{ name: 'homemodules'}">Módulos</router-link></li>
            <!-- <li class="hover-nav"><a>Servicios</a></li>
            <li class="hover-nav"><a>Blog</a></li> -->
            <!-- <li><label class="-mr-12 px-6 py-2 bg-secondary-900 rounded text-white boton">Contacto</label></li> -->
          </ul>
        </div>
        <span @click="openModal = !openModal" class="flex flex-col items-center justify-center lg:hidden cursor-pointer pr-6">
          <span class="bg-secondary-900 w-6 h-1 rounded-lg"></span>
          <span class="bg-secondary-900 my-1 w-8 h-1 rounded-lg"></span>
          <span class="bg-secondary-900 w-6 h-1 rounded-lg"></span>
        </span>
        <transition name="fade">
          <div class="flex flex-col absolute w-full h-full bg-primary-900 left-0 z-50" v-if="openModal">
            <div @click="openModal = !openModal" class="lg:hidden cursor-pointer text-white h-16 w-16 flex justify-center items-center self-end -mb-4">
              <span class="bg-primary-200 w-10 h-1 rounded-lg absolute transform cruz-45"></span>
              <span class="bg-primary-200 w-10 h-1 rounded-lg absolute transform -cruz-45"></span>
            </div>
            <ul class="font-sans leading-10 font-semibold tracking-wide text-white text-2xl flex flex-col pl-10 pt-8 responsive-nav">
              <li @click="openModal = !openModal"><router-link class="block py-2" :to="{ name: 'home'}">Inicio</router-link></li>
              <li @click="openModal = !openModal"><router-link class="block py-2" :to="{ name: 'advantages'}">Ventajas</router-link></li>
              <li @click="openModal = !openModal"><router-link class="block py-2" :to="{ name: 'homemodules'}">Módulos</router-link></li>
              <!-- <li><a>Servicios</a></li>
              <li><a>Blog</a></li> -->
              <!-- <li><a href="mailto:">Contacto</a></li> -->
            </ul>
          </div>
        </transition>
      </div>
    </nav>
    <router-view/>
    <footer class="bg-primary-900 mt-12">
      <div class="flex justify-center"><img src="@/assets/img/footer-up.webp" alt="Botón de scroll a inicio" @click="scrolltoTop()" class="cursor-pointer -mt-foot justify-middle absolute"></div>
      <div class="flex flex-wrap md:flex-no-wrap md:flex-row justify-start md:justify-between w-11/12 lg:max-w-5xl mr-4 md:mr-auto m-auto">
        <div class="h-40 mx-auto md:mx-0 mt-0 md:mt-10 lg:mt-8 mb-12 lg:mb-6 order-2 md:order-1">
          <img src="@/assets/img/logon.webp" style="max-height:65px;" alt="Logotipo de HBIM, una novedosa herramienta de integración online y visual de un bien cultural.">
          <p class="mt-4 mb-3 text-base sm:text-lg md:text-base lg:text-lg text-primary-500 font-sans">@HeritageBIM 2019 - Todos los derechos reservados</p>
          <!-- <div class="text-sm md:text-base">
            <ul class="flex text-secondary-700 list-none privacidad tracking-wide">
              <li class="hover:text-secondary-900 font-sans"><a href="">Aviso Legal</a></li>
              <p class="mx-3 text-white">·</p>
              <li class="hover:text-secondary-900 font-sans"><a href="">Política de Privacidad</a></li>
            </ul>
          </div> -->
        </div>
        <!-- <div class="flex self-start mx-auto md:mx-0 md:self-end flex-col mt-16 md:mt-0 lg:mt-12 mb-8 md:mb-10 lg:mb-4 order-1 md:order-2">
          <h1 class="self-end font-serif text-white font-bold text-2xl sm:text-3xl lg:text-4xl text-right tracking-wide">¿Interesado en HBIM?</h1>
          <div class="self-end w-16 h-1 bg-secondary-600"></div>
          <label class="self-end px-5 py-1 bg-secondary-900 font-semibold tracking-wide rounded text-white boton list-none my-5 font-sans">Pruébalo ahora</label>
        </div> -->
      </div>
    </footer>
  </div>
</template>

<style lang="scss">
#app {
}
</style>

<script>
export default {
  data () {
    return {
      openModal: ''
    }
  },
  methods: {
    scrolltoTop () {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>
